import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { update } from '../../../app/setters/update.js'
import { useNavigate } from 'react-router-dom'

export const useZmienDane = (setErrors) => {
    const queryClient = useQueryClient()
    const navigate = useNavigate()

    return useMutation({
        mutationFn: (data) => update('/uzytkownik/zmiana-danych', data),
        onSuccess: async (data) => {
            if (data?.status === 'success') {
                setErrors({})
                await queryClient.invalidateQueries({
                    queryKey: ['moje_dane'],
                })
                toast.success(
                    data?.message || 'Dane zostaly zmienione.'
                )
                navigate('/uzytkownik/moje-dane')
                return
            }

            if (data?.errors) {
                setErrors(data.errors)
            }

            toast.error(data?.message || 'Nie udalo sie zmienic danych.')
        },
        onError: (error) => {
            if (error?.response?.data?.errors) {
                setErrors(error.response.data.errors)
            }

            toast.error('Blad podczas zmiany danych.')
        },
    })
}
